/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    DateOfBirth: {
        id: 'qnb.spm.detailsPage.yourDetails.DateOfBirthPolicyHolder',
        defaultMessage: 'What is {possessivePronoun} date of birth?'
    },
    MaritalStatus: {
        id: 'qnb.spm.detailsPage.yourDetails.MaritalStatus',
        defaultMessage: 'What is your marital status?'
    },
    DupePersonError: {
        id: 'qnb.spm.detailsPage.yourDetails.DupePersonError',
        defaultMessage: 'You have already added this driver to your policy, please check the details above.'
    },
    EsolMessage: {
        id: 'qnb.spm.detailsPage.yourDetails.EsolMessage',
        defaultMessage: 'Please check your personal details and other information below, including your claims history for the last five years, to ensure its correct.'
    }
});
